"use client";

import { cn } from "@dafiti/closet-ui/utils";
import { PropsWithChildren, useEffect, useRef, useState } from "react";

export const StickyWrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const ref = useRef<HTMLDivElement>(null);

  const [top, setTop] = useState<number | undefined>(undefined);

  useEffect(() => {
    const calculateTop = () => {
      if (ref.current) {
        const containerHeight = ref.current.offsetHeight;

        const HEADER_HEIGHT = 108;

        // calculates the total pdp viewport except header
        const productViewportSize = window.innerHeight - HEADER_HEIGHT;

        // calculate total right container size including top margin to header
        const totalContainerSize = containerHeight + 70;

        const isContainerScrollable = totalContainerSize > productViewportSize;

        if (isContainerScrollable) {
          return setTop(productViewportSize - containerHeight + 82);
        }
      }
    };

    if (!ref.current) {
      return;
    }

    calculateTop();

    const resizeObserver = new ResizeObserver(calculateTop);

    resizeObserver.observe(ref.current);
    window.addEventListener("resize", calculateTop);

    return () => {
      window.removeEventListener("resize", calculateTop);
      resizeObserver.disconnect();
    };
  }, [ref]);

  return (
    <div
      className={cn(
        "lg:sticky transition-[top] duration-700 ease-in-out top-[140px] 2xl:top-[140px]",
        className,
      )}
      ref={ref}
      style={top ? { top } : undefined}
    >
      {children}
    </div>
  );
};
